
module.exports = require('./socket');

/**
 * Exports parser
 *
 * @api public
 *
 */
module.exports.parser = require('engine.io-parser');



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/socket.io-client/~/engine.io-client/lib/index.js
 ** module id = 16
 ** module chunks = 0
 **/